export const CustomFormGroup = ({
	children,
	formLabel,
	customEndComponent,
	error,
	light = false,
}) => (
	<div className="mb-3 w-100">
		<div
			className={`${
				light && "text-dark"
			} text-left ml-2 mb-1 text-light font-weight-bold d-flex justify-content-between align-items-center`}
		>
			{formLabel}
			{customEndComponent}
		</div>
		{children}
		{error && (
			<div className="text-center">
				<small className="text-danger">{error?.message}</small>
			</div>
		)}
	</div>
);
